import createErrorHandler from 'utils/createErrorHandler';

export default function validateBlacklistManageModalErrors(
  pauseStartDate,
  pauseEndDate
) {
  const [errors, addError] = createErrorHandler();

  if (!pauseStartDate) {
    addError('start_date', 'Please fill the pause from date.');
    return errors;
  } else if (!pauseEndDate) {
    addError('end_date', 'Please fill the resume from date.');
    return errors;
  }
  return false;
}
